const pendingStatuses = ['Atrasado', 'Em dia', 'Pendente']
const paidStatuses = ['Pago em dia', 'Pago com atraso']

export function matchesStatementFilter (item, filter, student) {
  const matchesStudent = !student || String(item.alumatricula) === String(student)
  const matchesStatus = filter === 'payed'
    ? paidStatuses.includes(item.situacao)
    : filter === 'npayed' ? pendingStatuses.includes(item.situacao) : true

  return matchesStudent && matchesStatus
}

export function groupStatementInstallments (statement) {
  const groups = [
    { id: 'overdue', titulo: 'Parcelas atrasadas', accepts: item => item.situacao === 'Atrasado' },
    { id: 'pending', titulo: 'Parcelas pendentes', accepts: item => ['Em dia', 'Pendente'].includes(item.situacao) },
    { id: 'history', titulo: 'Histórico do período', accepts: item => !pendingStatuses.includes(item.situacao) }
  ]

  return groups.map(group => {
    const anos = {}
    const years = Object.entries(statement || {}).sort(([a], [b]) => {
      const difference = Number(a.replace(/'/g, '')) - Number(b.replace(/'/g, ''))
      return group.id === 'history' ? -difference : difference
    })

    for (const [year, months] of years) {
      const visibleMonths = {}
      for (const [month, items] of Object.entries(months)) {
        const visible = items.filter(item => item.active && group.accepts(item))
          .sort((a, b) => (a.data_vencimento || a.data_pagamento || '')
            .localeCompare(b.data_vencimento || b.data_pagamento || ''))
        if (visible.length) visibleMonths[month] = visible
      }
      if (Object.keys(visibleMonths).length) anos[year] = visibleMonths
    }

    return { id: group.id, titulo: group.titulo, anos }
  }).filter(group => Object.keys(group.anos).length)
}
